import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Textarea = React.forwardRef(function Textarea2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      ref,
      className: cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props
    }
  );
});

export { Textarea };
//# sourceMappingURL=chunk-375TQAFA.js.map
//# sourceMappingURL=chunk-375TQAFA.js.map